module.exports = __webpack_public_path__ + "static/media/shift.cc3ec31c.svg";